import { Skeleton } from '@mui/material';
import clsx from 'clsx';
import Link from 'next/link';
import React, { Fragment } from 'react';
export const Breadcrumbs = ({
  items
}) => {
  return <nav className="text-sm font-medium text-foreground-muted">
            <ol className="flex flex-wrap items-center">
                {items.map((item, index) => <Fragment key={`${item.to}-${index}`}>
                        <li className="flex items-center whitespace-nowrap">
                            {item.isLoading ? <Skeleton width={100} /> : <Link href={item.to} {...item.params} className={clsx('text-sm text-primary hover:text-primary/80 transition', index === items.length - 1 && 'text-foreground!')}>
                                    {item.label}
                                </Link>}
                        </li>
                        {index < items.length - 1 && <span className="mx-2 text-foreground-subtle">/</span>}
                    </Fragment>)}
            </ol>
        </nav>;
};